export const getSXMenuProps = (isHovered: boolean, theme?: any, textTransform?: string, fontSize?: string) => ({
    PaperProps: {
        sx: {
            bgcolor: theme.colours.popover.backgroundColour,
            "& .MuiMenuItem-root": {
                minWidth: "13.5rem",
                textTransform: textTransform ?? null,
                fontSize: fontSize ?? null,
            },
            "& .Mui-selected": {
                textTransform: textTransform ?? null,
                fontSize: fontSize ?? null,
                backgroundColor: isHovered
                    ? `${theme.colours.popover.header.backgroundColour} !important`
                    : `${theme.colours.text.muted} !important`,
                color: isHovered
                    ? `${theme.colours.text.default} !important`
                    : `${theme.colours.text.reversed} !important`,
            },
        },
    },
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "left",
    },
    transitionDuration: 0,
    sx: {
        ul: {
            padding: 0,
        },
        "& .Mui-selected:hover": {
            backgroundColor: theme.colours.text.muted,
            color: theme.colours.text.reversed,
        },
        "& li:hover, & li:focus, & .Mui-selected, & .Mui-selected:focus, && .MuiMenuItem-root.Mui-selected": {
            backgroundColor: theme.colours.text.muted,
            color: theme.colours.text.reversed,
        },
    },
    elevation: 1,
    disableScrollLock: true,
})
